import { toast } from "sonner";

type ProblemDetails = { title?: string | null; detail?: string | null; status?: number };

type OpenApiFetchResult = { error?: unknown; response?: Response };

async function extractProblem(input: Response | OpenApiFetchResult | unknown): Promise<ProblemDetails | null> {
  if (input instanceof Response) {
    try {
      return (await input.clone().json()) as ProblemDetails;
    } catch {
      return null;
    }
  }
  if (input && typeof input === "object") {
    const obj = input as OpenApiFetchResult & { detail?: string | null; title?: string | null };
    if (obj.error && typeof obj.error === "object") {
      const err = obj.error as ProblemDetails;
      if (err.detail || err.title) return err;
    }
    if (obj.response instanceof Response) {
      try {
        return (await obj.response.clone().json()) as ProblemDetails;
      } catch {
        // fall through
      }
    }
    if (obj.detail || obj.title) return { detail: obj.detail, title: obj.title };
  }
  return null;
}

export async function toastApiError(
  input: Response | OpenApiFetchResult | unknown,
  fallback: string,
): Promise<void> {
  const problem = await extractProblem(input);
  const title = problem?.title?.trim() || fallback;
  const description = problem?.detail?.trim() || undefined;
  toast.error(title, { description });
}

export function toastApiSuccess(message: string, description?: string): void {
  toast.success(message, description ? { description } : undefined);
}
